<div [style.width]="width" [style.height]="height" #mapContainer id="mapContainer"></div>
<app-draw-pane #drawPane [map]="this" [(isOn)]="drawpaneOn" (isOnChange)="HandleDrawpanePowerChange($event)"
  class="container-draw hidden" type="line" [style.width]="width" [style.height]="height"
  [spatialContext]="spatialContext"></app-draw-pane>
